import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const AdventCalendarPage = lazyWithRetry(() =>
  import("@/features/adventCalendar/pages/AdventCalendarPage").then((m) => ({ default: m.AdventCalendarPage })));

export const ADVENT_CALENDAR_PATH = "/advent-calendar";

const adventCalendarRoutes: RouteConfig[] = [
  {
    path: ADVENT_CALENDAR_PATH,
    element: <AdventCalendarPage />,
    isProtected: true,
    useMainLayout: false,
  },
];

export default adventCalendarRoutes;
